<template>
  <v-container class="mt-14 pa-0 sales-container" fluid>
    <!-- ===== Floating Left Tab (shown after popup is closed) ===== -->
    <transition name="slide-tab">
      <button
        v-if="
          !announcementStore.showModal &&
          announcementStore.publishedAnnouncements.length > 0
        "
        class="announcement-tab"
        @click="announcementStore.openModal()"
      >
        <v-icon size="16" color="white">mdi-bullhorn</v-icon>
        <span>Announcement</span>
      </button>
    </transition>

    <!-- Announcements Modal is now global in TopNavbar.vue -->

    <div class="cards-grid mt-12">
      <cardComp v-for="card in cards_data" :key="card.id" :card="card" />
    </div>
  </v-container>
</template>

<script>
import cardComp from "../components/homePage/cardComp.vue";
import { useHomePageStore } from "../stores/homePageStore";
import { useAnnouncementStore } from "@/stores/announcements";
import { useAuthStore } from "@/stores/auth";

export default {
  name: "HomeView",

  components: {
    cardComp,
  },

  data() {
    return {
      homePageStore: useHomePageStore(),
      announcementStore: useAnnouncementStore(),
      colors: ["#7FE47E", "#9FCCFF", "#FFEB3A", "#FF718B"],
      agingLabels: {
        goods: "<90 days",
        normal: "91–180 days",
        mid: "181–360 days",
        old: ">360 days",
      },
      // ... other data
      backOrderCards: [],
    };
  },
  computed: {
    todayFormatted() {
      return new Date().toLocaleDateString("en-US", {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    },
    homeData() {
      return this.homePageStore.homeData || {};
    },
    kpi() {
      return this.homeData.kpi || {};
    },
    cards_data() {
      const auth = useAuthStore();
      const role = auth.user?.role?.toLowerCase();
      const isUser = role === "user";

      return this.homePageStore.cards_data.map((card) => {
        if (card.title === "Purchasing" && isUser) {
          return { ...card, disabled: true };
        }
        return card;
      });
    },
  },
};
</script>

<style>
/* ===== Announcement Tab ===== */
.announcement-tab {
  position: fixed;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  z-index: 999;
  background: #00363f;
  color: white;
  border: none;
  border-radius: 0 12px 12px 0;
  padding: 12px 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  box-shadow: 2px 0 12px rgba(0, 0, 0, 0.15);
  transition: background 0.2s;
}
.announcement-tab:hover {
  background: #005060;
}
.announcement-tab span {
  writing-mode: vertical-rl;
  text-orientation: mixed;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.5px;
}

/* Transition for the tab */
.slide-tab-enter-active,
.slide-tab-leave-active {
  transition: transform 0.3s ease, opacity 0.3s ease;
}
.slide-tab-enter-from,
.slide-tab-leave-to {
  transform: translateY(-50%) translateX(-100%);
  opacity: 0;
}

/* ===== Announcement Popup Card ===== */
.announce-card {
  overflow: hidden;
  border: 1px solid #eef0f2;
}
.announce-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  background: linear-gradient(180deg, #fff 0%, #f9fbfc 100%);
}
.announce-header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}
.announce-icon-wrap {
  width: 40px;
  height: 40px;
  background: linear-gradient(135deg, #00363f, #00a896);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.announce-label {
  font-weight: 700;
  font-size: 15px;
  color: #00363f;
}
.announce-date {
  font-size: 11px;
  color: #708083;
  margin-top: 1px;
}
.announce-body {
  padding: 24px 24px 20px;
}
.announce-title {
  font-size: 20px;
  font-weight: 700;
  color: #01252b;
  margin-bottom: 10px;
}
.announce-text {
  font-size: 14px;
  color: #596a6d;
  line-height: 1.7;
  margin-bottom: 20px;
}
.announce-highlights {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.announce-hl-item {
  display: flex;
  align-items: center;
  gap: 10px;
  background: #f0fafa;
  border-radius: 10px;
  padding: 10px 14px;
  font-size: 13px;
  color: #01252b;
  font-weight: 500;
}
.announce-footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 12px 20px;
}

/* ===== General ===== */
.header-title {
  font-size: 24px;
  font-weight: 700;
  color: #0b3b41;
}
.home-details {
  padding: 60px 48px;
}
.cards-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  column-gap: 1.25vw;
  row-gap: 4vw;
  justify-items: center;
  align-items: start;
  margin-bottom: 4vw;
  padding: 0 2vw;
}
.ach-card-bg-white {
  box-shadow: 0px 2px 20px 0px rgba(49, 65, 88, 0.1);
  border: 1px solid rgba(226, 232, 240, 1);
  padding: 20px 24px;
  border-radius: 32px;
  height: 100%;
}

.ach-card {
  background: linear-gradient(135deg, #00363f 0%, #015764 50%, #007586 100%);
  border-radius: 16px;
  padding: 24px;
  color: white;
  box-shadow: 0 4px 20px rgba(0, 54, 63, 0.3);
}

.ach-card .card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.ach-card .card-header h2 {
  font-size: 16px;
  font-weight: 500;
  opacity: 0.9;
}

.ach-card .card-header .icon {
  width: 40px;
  height: 40px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ach-card .card-body .values {
  margin-bottom: 16px;
}

.ach-card .card-body .values span p {
  font-size: 50px;
  font-weight: 700;
  margin: 0;
  line-height: 1;
}

.ach-card .card-body .persentage {
  gap: 8px;
}

.ach-card .card-body .persentage span {
  font-size: 14px;
  font-weight: 500;
  opacity: 0.8;
}

@media (max-width: 1200px) {
  .cards-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}
@media (max-width: 768px) {
  .cards-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

.consignment-card {
  box-shadow: 0px 2px 20px 0px #3141581a;
  border: 1px solid #e2e8f0;
  border-radius: 20px;
  padding: 32px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  height: 100%;
}

.chart {
  width: 100%;
  height: 260px;
}

.legend-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px 30px;
  margin-top: 10px;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #0f172a;
}

.legend-item .dot {
  width: 14.22px;
  height: 14.22px;
  border-radius: 50%;
}

.legend-item .value {
  margin-left: auto;
  font-weight: 400;
  font-size: 14px;
  color: rgba(89, 106, 109, 1);
}
</style>
